import { getPortalId } from './getPortalId';
const isFromThisPortal = e => {
  var _e$data;
  return ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.portalId) === getPortalId();
};
export function isNotificationsMenuOpenedMessage(e) {
  var _e$data2;
  return ((_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.type) === 'notifications-menu-opened' && isFromThisPortal(e);
}
export const isSetUnseenNotificationsCountMessage = e => {
  var _e$data3;
  return ((_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.type) === 'set-unseen-count' && isFromThisPortal(e);
};
export const isUserSettingsUpdatedMessage = e => {
  var _e$data4;
  return ((_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.type) === 'USER_SETTINGS_UPDATED' && isFromThisPortal(e);
};
export const broadcastNotificationMessage = message => {
  if ('BroadcastChannel' in window) {
    const portalId = getPortalId();
    const channel = new BroadcastChannel('notifications-events');
    if (typeof message === 'string') {
      channel.postMessage({
        portalId,
        type: message
      });
    } else {
      channel.postMessage(Object.assign({
        portalId
      }, message));
    }
    channel.close();
  }
};